import React from 'react';
import {
  Grid,
  Card,
  CardHeader,
  Divider,
  CardContent,
  MenuItem,
  CardActions,
  makeStyles,
  Theme,
  createStyles,
} from '@material-ui/core';
import {
  AutoFocusedForm,
  required,
  email,
  SelectField,
  TextField,
  composeValidators,
} from 'components';
import { Field } from 'react-final-form';
import { useModeratorForm } from './useModeratorForm';
import { AdministratorsKind } from 'schema/serverTypes';
import { kindNames } from 'schema/kinds';
import { MutableButton } from 'ui/MutableButton';
import { RedButton } from 'components/Buttons';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {},
    header: {
      fontWeight: 'bolder',
    },
    divider: {},
    content: {},
    actions: {
      justifyContent: 'flex-end',
    },
    accessButton: {
      color: theme.palette.common.white,
      backgroundColor: theme.palette.success.dark,
      '&:hover': {
        color: theme.palette.success.dark,
        backgroundColor: theme.palette.success.light,
      },
    },
  })
);

export interface CreateModeratorFormProps {
  onClose: () => void;
}

export const CreateModeratorForm = ({ onClose }: CreateModeratorFormProps) => {
  const styles = useStyles();

  const { onSubmit, initialValues, loading } = useModeratorForm(onClose);
  return (
    <AutoFocusedForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      subscription={{
        submitError: true,
      }}
      render={({ handleSubmit, pristine }) => {
        return (
          <form onSubmit={handleSubmit}>
            <Card className={styles.root}>
              <CardHeader title="Добавление администратора" />
              <Divider className={styles.divider} />
              <CardContent className={styles.content}>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="kind"
                      component={SelectField}
                      label="Тип пользователя"
                      validate={required}
                    >
                      <MenuItem value={AdministratorsKind.SystemAdministrators}>
                        {kindNames[AdministratorsKind.SystemAdministrators]}
                      </MenuItem>
                      <MenuItem value={AdministratorsKind.Moderators}>
                        {kindNames[AdministratorsKind.Moderators]}
                      </MenuItem>
                    </Field>
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="displayName"
                      label="Имя пользователя"
                      component={TextField}
                      validate={required}
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={4}>
                  <Grid item lg={12} md={12} xl={12} xs={12}>
                    <Field
                      name="email"
                      label="Адрес электронной почты"
                      component={TextField}
                      validate={composeValidators(required, email)}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className={styles.actions}>
                <MutableButton
                  loading={loading}
                  color="primary"
                  disabled={pristine}
                  size="medium"
                  type="submit"
                  variant="contained"
                  className={styles.accessButton}
                >
                  Добавить
                </MutableButton>
                <RedButton
                  onClick={onClose}
                  disabled={loading}
                  size="medium"
                  type="button"
                  variant="contained"
                >
                  Отменить
                </RedButton>
              </CardActions>
            </Card>
          </form>
        );
      }}
    />
  );
};
